import React, { useReducer } from 'react'
import { types } from '../Types/types';
import { AuthContext } from './AuthContext';
import { authReducer } from './authReducer';

const initialState = {
    logged: false
}

const init = () => {
    const user = localStorage.getItem('user_campuses_institute');

    return {
        logged: !!user,
        user: user
    }
}

export const AuthProvider = ({children}) => {
    
    const [authState, dispatch] = useReducer(authReducer, initialState, init);

    const login = (name = '', email = '', id = '') => {

        const user = {
            id: 'ABC',
            name: name,
            email: email
        }

        const action = {
            type: types.login,
            payload: user
        }

        localStorage.setItem('user_campuses_institute', JSON.stringify(user));

        dispatch(action);
    }

    const logout = () => {
        localStorage.removeItem('user_campuses_institute');

        dispatch({
            type: types.logout
        })
    }
    
    return (
        <AuthContext.Provider
            value={{
                ...authState,
                login,
                logout
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}
